/* eslint-disable react/require-default-props */
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { ReactElement } from 'react';

import { IoCloseSharp } from 'react-icons/io5';
import { MdFileDownload } from 'react-icons/md';
import { toast } from 'react-toastify';

import { ModalInfo, Button, Select, DatePicker } from '~/components';
import { useLoading } from '~/hooks/loading';
import ProfessionalService from '~/services/Professional';
import ReportsService from '~/services/Reports';

import ContainerDate from '../ContainerDate';

import { FormWrapper } from '../CollaboratorModal/styles';
import * as S from './styles';

interface IConfirmModalProps {
  modalIsVisible: boolean;
  setModalIsVisible: Dispatch<SetStateAction<boolean>>;
}

function DownloadReports({
  modalIsVisible,
  setModalIsVisible,
}: IConfirmModalProps): ReactElement {
  const [selectedProfessional, setSelectedProfessional] = useState<
    string | null
  >(null);
  const [professionals, setProfessionals] = useState<
    { label: string; value: string }[]
  >([]);

  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const { setLoading } = useLoading();

  const handleDownloadReport = async () => {
    if (!selectedProfessional || !startDate || !endDate) {
      toast.error('Por favor, preencha todos os campos.');
      return;
    }
    if (startDate > endDate) {
      toast.error('A data de início não pode ser maior que a data de fim.');
      return;
    }
    try {
      setLoading(true);
      const starDateFormatted = startDate
        ? startDate.toISOString().split('T')[0]
        : '';
      const endDateFormatted = endDate
        ? endDate.toISOString().split('T')[0]
        : '';
      const response = await ReportsService.getReportStudents({
        startDate: starDateFormatted,
        endDate: endDateFormatted,
        professionalId: selectedProfessional || '',
      });
      if (response) {
        const link = document.createElement('a');
        link.target = '_blank';
        link.download = `IB_relatorio_de_alunos`;
        link.href = URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/pdf',
          }),
        );
        link.click();
      }
    } catch (error) {
      toast.error('Erro ao baixar relatório.');
    } finally {
      setLoading(false);
    }
  };

  const getProfessionals = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await ProfessionalService.getAllUsers({
        perpage: 1000,
        searchFilter: '',
      });
      if (data.data) {
        const usersMapped = data.data.map((user) => {
          return {
            label: user.name,
            value: String(user.professional?.id),
          };
        });
        setProfessionals(usersMapped);
        setSelectedProfessional(usersMapped[0]?.value || '');
      }
    } catch (error) {
      toast.error('Erro ao buscar profissionais.');
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const closeModal = () => {
    setModalIsVisible(false);
    setSelectedProfessional(null);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  useEffect(() => {
    if (modalIsVisible) getProfessionals();
  }, [getProfessionals, modalIsVisible]);
  return (
    <ModalInfo
      modalVisible={modalIsVisible}
      setModalVisible={setModalIsVisible}
      containerStyle={{
        justifyContent: 'flex-start',
        padding: '3rem',
        alignItems: 'flex-start',
      }}
    >
      <S.ConfirmDeleteContainer>
        <S.HeaderContainer>
          <S.ConfirmDeleteTitle>BAIXAR RELATÓRIO</S.ConfirmDeleteTitle>
          <IoCloseSharp
            style={{ cursor: 'pointer' }}
            size={30}
            onClick={closeModal}
          />
        </S.HeaderContainer>
        <S.Divider />
        <S.ConfirmDeleteText />
        <FormWrapper
          onSubmit={() => console.log('')}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            paddingBottom: '48px',
          }}
        >
          <Select
            name="gym"
            value={selectedProfessional || ''}
            onChange={(e) => setSelectedProfessional(e.target.value)}
            options={professionals}
            containerStyle={{ height: '40px', fontSize: '13px' }}
          />
          <S.DataPickerContainer>
            <ContainerDate label="Data início">
              <DatePicker
                name="initial_date"
                fieldLabel=""
                value={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </ContainerDate>
            <ContainerDate label="Data fim">
              <DatePicker
                name="final_date"
                fieldLabel=""
                value={endDate}
                onChange={(date) => setEndDate(date)}
              />
            </ContainerDate>
          </S.DataPickerContainer>
        </FormWrapper>
        <S.ConfirmDeleteButtonGroup>
          <Button
            size="small"
            textContent="Cancelar"
            onClick={closeModal}
            variant="red"
            extraStyles={{
              width: '200px',
              maxWidth: '300px',
              maxHeight: 35,
            }}
          />
          <Button
            size="small"
            icon={<MdFileDownload size={22} color="#ffffff" />}
            textContent="Baixar relatório"
            variant="black"
            onClick={handleDownloadReport}
            extraStyles={{
              width: '200px',
              maxWidth: '300px',
              maxHeight: 35,
            }}
          />
        </S.ConfirmDeleteButtonGroup>
      </S.ConfirmDeleteContainer>
    </ModalInfo>
  );
}

export default DownloadReports;
